interface AiMessageBubbleProps {
  content: string;
}

export function AiMessageBubble({ content }: AiMessageBubbleProps) {
  return (
    <div className="flex items-center gap-[10px] self-stretch pr-10 lg:pr-0">
      <p className="text-base font-normal leading-6 tracking-[-0.01em] text-[#000000] whitespace-pre-wrap">
        {content}
      </p>
    </div>
  );
}
